module.exports = __webpack_public_path__ + "img/voce-quer-alugar-sua-bicicleta.7e5bf0c0.svg";